import {
  AttachFile, BusinessCenter, Class, Mail,
  MenuBook, NotificationsActive, School, Security,
  Storage as StorageIcon, Telegram, WhatsApp
} from '@mui/icons-material';

export const COLORS = {
  backgroundColorDarkTheme: 'var(--app-bg)',
  tableBackgroundColor: 'var(--app-surface-1)',
  tableHeaderColor: 'var(--app-surface-header)',
  borderColorDarkTheme: 'var(--app-table-border)',
  fontColorDarkTheme: 'var(--app-text)',
};

export const PLATFORMS_CONFIG = [
  { name: 'ActiveSoft', icon: <School fontSize="small" /> },
  { name: 'AppAlertAi', icon: <NotificationsActive fontSize="small" /> },
  { name: 'ClassApp', icon: <Class fontSize="small" /> },
  { name: 'ClipEscola', icon: <AttachFile fontSize="small" /> },
  { name: 'DefenseBridge', icon: <Security fontSize="small" /> },
  { name: 'Email', icon: <Mail fontSize="small" /> },
  { name: 'GVDASA', icon: <StorageIcon fontSize="small" /> }, 
  { name: 'Sophia', icon: <MenuBook fontSize="small" /> },
  { name: 'Telegram', icon: <Telegram fontSize="small" /> },
  { name: 'Unimestre', icon: <BusinessCenter fontSize="small" /> },
  { name: 'WhatsApp', icon: <WhatsApp fontSize="small" /> },
];
